import { MerchantLoginWidget } from '~widgets/merchant-login';

import { userPhoneAtom } from '~entities/auth';

import { Logo } from '~shared/ui/logo';

import { useAtom } from 'jotai';

export const LoginPage = () => {
  const [lastUserPhone, setLastUserPhone] = useAtom(userPhoneAtom);

  return (
    <div
      className={`
        flex h-full w-full flex-col items-center justify-center bg-login-page
        bg-cover
      `}
    >
      <div
        className={`box-border h-[400px] w-[440px] rounded-xl bg-white p-[60px]`}
      >
        <div className="mb-6">
          <Logo />
        </div>

        <MerchantLoginWidget
          initialPhone={lastUserPhone || ''}
          onConfirmSuccess={(phoneNumber: string) => {
            setLastUserPhone(phoneNumber);
            window.location.replace(`/?date=${new Date().getTime()}`);
          }}
        />
      </div>
    </div>
  );
};
